module.exports = __webpack_public_path__ + "static/media/login-warning.01bf230b.png";